import { render } from "./ChangeTemplate.vue?vue&type=template&id=43612650"
import script from "./ChangeTemplate.vue?vue&type=script&lang=js"
export * from "./ChangeTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__